import { takeLatest } from 'redux-saga/effects';
import { EMapToolActionType } from '../../store/actions/MapToolActionType';
import { graticuleHandler } from '../viewer/tools/makeGraticule';

/**
 * Defines sagas for changes to `showGridOverlay`.
 */
export default function* watchSetGridOverlay() {
  yield takeLatest(EMapToolActionType.SET_GRIDOVERLAY, manageGraticule);
}
/**
 * Generator function for `showGridOverlay` related actions.
 * @param action
 */
function* manageGraticule(action) {
  const { showGridOverlay } = action;
  if (graticuleHandler && graticuleHandler.toggle) {
    showGridOverlay ? graticuleHandler.show() : graticuleHandler.hide();
    yield true;
  }
  yield false;
}
